import {
  FloatingFormItem,
  InputDate,
  InputDecimal,
} from '@/components/_common';
import { useIndividualTicketChange } from '@/core/domain/financial/Boletos/Boletos.hooks';
import { ListBillets } from '@/core/domain/financial/Boletos/Boletos.types';
import { DateTimeFormat } from '@/utils/moment';
import { Col, Form, Modal, ModalProps, Row } from 'antd';

interface Props extends Omit<ModalProps, 'onCancel'> {
  onCancel?: () => void;
  data?: ListBillets;
}

export default function BankSlipEditModal(props: Props) {
  const [form] = Form.useForm();

  const individualTicketChange = useIndividualTicketChange();

  const handleCancel = () => {
    form.resetFields();
    props.onCancel?.();
  };

  const handleOk = () => {
    Modal.confirm({
      title: 'Solicitação de alteração',
      content:
        'Pode ser necessário aguardar a atualização do banco. Deseja realmente continuar?',
      okText: 'Solicitar',
      cancelText: 'Cancelar',
      onOk: async () => {
        try {
          const values = await form.validateFields();

          if (!!props.data) {
            await individualTicketChange.mutateAsync({
              ...values,
              integrationId: props.data.integrationId,
              titleDueDate: values.titleDueDate
                ? values.titleDueDate.format(DateTimeFormat)
                : undefined,
              titleProtestTerm: values.titleProtestTerm
                ? values.titleProtestTerm.format(DateTimeFormat)
                : undefined,
            });
          }
        } finally {
          handleCancel();
        }
      },
    });
  };

  return (
    <Modal
      {...props}
      title="Solicitação de alteração de Boleto"
      okText="Solicitar"
      onCancel={handleCancel}
      onOk={handleOk}
    >
      <Form form={form} layout="vertical">
        <Row gutter={[12, 12]}>
          <Col span={24} md={12}>
            <FloatingFormItem label="Valor" name="titleValue">
              <InputDecimal min={0} />
            </FloatingFormItem>
          </Col>

          <Col span={24} md={12}>
            <FloatingFormItem label="Vencimento" name="titleDueDate">
              <InputDate />
            </FloatingFormItem>
          </Col>

          <Col span={24} md={12}>
            <FloatingFormItem
              label="Valor de Desconto"
              name="titleDiscountValue"
            >
              <InputDecimal min={0} />
            </FloatingFormItem>
          </Col>

          <Col span={24} md={12}>
            <FloatingFormItem
              label="Valor de Abatimento"
              name="titleRebateValue"
            >
              <InputDecimal min={0} />
            </FloatingFormItem>
          </Col>

          <Col span={24} md={12}>
            <FloatingFormItem
              label="Código de Protesto"
              name="titleCodeProtest"
            >
              <InputDecimal min={0} />
            </FloatingFormItem>
          </Col>

          <Col span={24} md={12}>
            <FloatingFormItem label="Data de Protesto" name="titleProtestTerm">
              <InputDate />
            </FloatingFormItem>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
